// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:1023px){.listComponentWrapper.navigating.selected[data-v-33f17b3e],.listComponentWrapper[data-v-33f17b3e]:hover{background:unset}}", ""]);
// Exports
module.exports = exports;
